import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { css } from 'emotion';

/**
 * Renders a non-modal status bar that can show jobs running in the
 * background.  For now I'm using the same layout as the login bar, but we can move this to bottom or elsewhere.
 *
 * TODO: this needs to be finished...
 */
export default class StatusBar extends React.Component {
    static propTypes = {
        messages: PropTypes.array.isRequired,
        userLoggedIn: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
    }

    componentDidMount() {
        // listen for clicks outside our component so we can hide the login form
        window.PCM.appContainer.addEventListener('click', this.onDocumentClick);
    }

    componentWillUnmount() {
        //remove our document listener
        window.PCM.appContainer.removeEventListener('click', this.onDocumentClick);
    }

    onLoginDropdownClick = (e) => {
        const newState = !this.state.open;
        this.setState({
            open: newState
        });
    };

    onDocumentClick = (e) => {
        const area = ReactDOM.findDOMNode(this);

        if (!area.contains(e.target) && this.state.open) {
            this.setState({
                open: false
            });
        }
    };

    renderMessages() {
        const topMessage = this.props.messages[0].modalMessage;
        const messages = this.props.messages.map((modalConfig, index) => {

            return (
                <div key={index}>
                    <span>{modalConfig.modalMessage}</span>
                </div>
            );
        });

        const className = this.props.userLoggedIn ? '' :
            css`
                margin-top: 40px;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
            `;

        return (
            <div className={`${className} login-container dropdown open`} style={{ zIndex: 49 }}>
                <span className="login-alert">{topMessage}</span>
            </div>
        );
    }

    /**
     * We can't use bootstrap react components here because the bootstrap react dropdown menu was not intended to
     * include an embedded form, and it causes all sorts of problems with event handlers.
     * @returns {XML}
     */
    render() {
        if (this.props.messages && this.props.messages.length > 0) {
            return this.renderMessages();
        }
        return <div/>;
    }
}



// WEBPACK FOOTER //
// ./src/components/core/StatusBar.js